/**
 * MetaRow — compact row of icon+text meta items separated by subtle dots.
 *
 * Items are objects { icon, text, tone?, title? }.
 * Falsy/null items are skipped silently. If all items are skipped, returns null.
 *
 * Usage:
 *   <MetaRow items={[
 *     { icon: <Calendar size={11}/>, text: "vence mañana", tone: "amber" },
 *     { icon: <User size={11}/>,     text: "Ana López" },
 *   ]} />
 */
import React from "react";

const TONE_TEXT = {
  stone: "text-stone-500",
  amber: "text-amber-700",
  red:   "text-red-600",
  emerald: "text-emerald-700",
};

export default function MetaRow({ items = [], className = "" }) {
  const visible = items.filter(Boolean);
  if (visible.length === 0) return null;
  return (
    <div className={`flex flex-wrap items-center gap-x-2 gap-y-1 text-[11px] ${className}`}>
      {visible.map((it, i) => (
        <React.Fragment key={i}>
          {i > 0 && <span className="text-stone-300">·</span>}
          <span
            title={it.title}
            className={`inline-flex items-center gap-1 ${TONE_TEXT[it.tone] || TONE_TEXT.stone}`}
          >
            {it.icon}
            <span className="truncate">{it.text}</span>
          </span>
        </React.Fragment>
      ))}
    </div>
  );
}
